import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import useEmailTemplatesStore from 'src/stores/emailTemplatesStore';
import EmailTemplatesList from './EmailTemplatesList';

const EmailTemplatesListResolver = () => {
  const { fetchTemplates } = useEmailTemplatesStore(s => s);

  const loadDependencies = () =>
    Promise.all([
      fetchTemplates().catch(() => undefined),
    ] as Array<Promise<void | AxiosResponse<unknown>>>);

  return <Resolver resolve={loadDependencies} successComponent={EmailTemplatesList} />;
};

export default EmailTemplatesListResolver;
